import React, { FC, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { FirebaseTimestamp, db } from 'firebase/index'
import { State } from 'index'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { BlueButton, GreyButton } from 'components/Button'
import { SelectBox, TextInput } from 'components/Form'
import { FormLabel } from 'components/Label'
import { Description } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { useSelect, useString } from 'hooks/form'
import { getBrandRef } from 'reducks/auth/selectors'
import { getPointCard } from 'reducks/pointCard/selectors'
import { fetchPointCardCode, setPointCardCode } from 'repos/pointCard/pointCardCode'

type Props = {
  isEdit: boolean
  pointCardCodeId?: string
}

const PointCardCodeEditTemplate: FC<Props> = (props) => {
  const { isEdit, pointCardCodeId } = props

  const dispatch = useDispatch()
  const brandRef = useSelector((state: State) => getBrandRef(state))
  const pointCard = useSelector((state: State) => getPointCard(state))

  const { state: name, handleState: handleName, setState: setName } = useString<string>('')
  const { state: points, handleState: handlePoints, setState: setPoints } = useSelect<string>('1')

  const grantPointOptions = Array.from({ length: 20 }, (_, i) => ({ label: `${i + 1}pt`, value: `${i + 1}` }))

  const savePointCardCode = async () => {
    const now = FirebaseTimestamp.now()
    const pointCardRef = pointCard.ref
    const pointCardCode = isEdit && pointCardCodeId ? await fetchPointCardCode(pointCardRef.id, pointCardCodeId) : null
    const ref = isEdit
      ? db.collection('point_cards').doc(pointCardRef.id).collection('point_card_codes').doc(pointCardCodeId)
      : db.collection('point_cards').doc(pointCardRef.id).collection('point_card_codes').doc()
    await setPointCardCode({
      ref: ref,
      brand_ref: brandRef,
      point_card_ref: pointCardRef,
      name: name,
      code: ref.id,
      points: parseInt(points),
      created_at: isEdit && pointCardCode ? pointCardCode.created_at : now,
      updated_at: now,
    })
    dispatch(push('/point_card/code/list'))
  }

  useEffect(() => {
    ;(async () => {
      if (!isEdit || !pointCardCodeId || !pointCard) return
      const pointCardCode = await fetchPointCardCode(pointCard.ref.id, pointCardCodeId)
      if (!pointCardCode) return
      setName(pointCardCode.name)
      setPoints(pointCardCode.points.toString())
    })()
  }, [isEdit, pointCardCodeId, pointCard])

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <Description description={'必要な情報を入力して、QRコードを作成してください'} />
      <Spacer size={20} />
      <TextInput
        disabled={false}
        label={'QRコード名称'}
        onChange={handleName}
        required={true}
        placeholder={'QRコード'}
        type={'text'}
        size={'small'}
        value={name}
      />
      <Spacer size={20} />
      <FormLabel label={'付与するポイント'} required={true} />
      <Spacer size={8} />
      <SelectBox options={grantPointOptions} select={handlePoints} value={points} />
      <Spacer size={40} />
      <BlueButton label={'保存する'} onClick={savePointCardCode} size={'medium'} type={'main'} />
      <Spacer size={24} />
      <GreyButton
        label={'QRコードに戻る'}
        onClick={() => dispatch(push('/point_card/code/list'))}
        size={'medium'}
        type={'outlined'}
      />
      <Spacer size={40} />
    </div>
  )
}

export default PointCardCodeEditTemplate
